/* Elvera Cosmetics — themagedrag
   Mobiel menu, winkelmand-drawer (met section rendering) en productgalerij. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Mobiel menu ----------------------------------------------------------- */
  var burger = qs('[data-menu-toggle]');
  var mobileNav = qs('[data-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Winkelmand-drawer ----------------------------------------------------- */
  var drawer = qs('[data-cart-drawer]');
  var overlay = qs('[data-cart-overlay]');

  function openDrawer() {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  }

  qsa('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  });
  qsa('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* Cart verversen via section rendering ---------------------------------- */
  function refreshCart(open) {
    return fetch(root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-cart-drawer-content]', doc);
        var current = qs('[data-cart-drawer-content]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var count = qs('[data-cart-count]', doc);
        var countNow = qs('[data-cart-count]');
        if (count && countNow) countNow.textContent = count.textContent;
        var headerCount = qs('[data-cart-count]', doc);
        var headerNow = qs('.cart-count');
        if (headerCount && headerNow) headerNow.textContent = headerCount.textContent.trim();
        if (open) openDrawer();
        bindCartControls();
      })
      .catch(function () {});
  }

  function changeLine(key, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshCart(false); });
  }

  function bindCartControls() {
    qsa('[data-qty-change]').forEach(function (btn) {
      btn.onclick = function () {
        var key = btn.getAttribute('data-key');
        var input = qs('[data-qty-input][data-key="' + key + '"]');
        if (!input) return;
        var next = parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-change'), 10);
        if (next < 0) next = 0;
        changeLine(key, next);
      };
    });
    qsa('[data-line-remove]').forEach(function (btn) {
      btn.onclick = function (e) { e.preventDefault(); changeLine(btn.getAttribute('data-key'), 0); };
    });
    qsa('[data-qty-input]').forEach(function (input) {
      input.onchange = function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 0) v = 1;
        changeLine(input.getAttribute('data-key'), v);
      };
    });
  }
  bindCartControls();

  /* Productformulieren (ajax toevoegen) ----------------------------------- */
  qsa('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!form.checkValidity()) return;
      e.preventDefault();
      var btn = qs('[type="submit"]', form);
      if (btn) { btn.disabled = true; btn.classList.add('is-disabled'); }
      fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(true); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-disabled'); } });
    });
  });

  /* Productgalerij -------------------------------------------------------- */
  qsa('[data-gallery]').forEach(function (gallery) {
    var main = qs('[data-gallery-main]', gallery);
    qsa('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) main.src = thumb.getAttribute('data-src');
        qsa('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* Aantal-steppers ------------------------------------------------------- */
  qsa('[data-stepper]').forEach(function (wrap) {
    var input = qs('input', wrap);
    qsa('button', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10);
        var v = (parseInt(input.value, 10) || 1) + step;
        if (v < 1) v = 1;
        input.value = v;
      });
    });
  });
})();